package io.horion.auth.domain.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

object AuthState {
    var currentUser by mutableStateOf<User?>(null)
        private set

    var isAuthenticated by mutableStateOf(false)
        private set

    fun setUser(user: User) {
        currentUser = user
        isAuthenticated = true
    }

    fun clearUser() {
        currentUser = null
        isAuthenticated = false
    }

    fun updateUser(updatedUser: User) {
        currentUser = updatedUser
    }
}